import React, { useState, useEffect } from 'react';
import settingsService from '../services/settingsService';
import './SettingsPage.css';

const SettingsPage = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [testEmail, setTestEmail] = useState('');
  
  const [settings, setSettings] = useState({
    smtp_host: '',
    smtp_port: '587',
    smtp_user: '',
    smtp_password: '',
    smtp_from_name: 'Obstnatur',
    smtp_from_email: ''
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await settingsService.getEmailSettings();
      setSettings(data);
    } catch (error) {
      setError('Fehler beim Laden der Einstellungen');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field) => (event) => {
    setSettings({
      ...settings,
      [field]: event.target.value
    });
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    setSuccess('');
    
    try {
      await settingsService.updateEmailSettings(settings);
      setSuccess('Einstellungen gespeichert');
    } catch (error) {
      setError('Fehler beim Speichern');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  const handleTest = async () => {
    if (!testEmail) {
      setError('Bitte Test-Email-Adresse eingeben');
      return;
    }
    
    setTesting(true);
    setError('');
    setSuccess('');
    
    try {
      await settingsService.testEmail(testEmail);
      setSuccess(`Test-Email an ${testEmail} gesendet`);
    } catch (error) {
      setError(error.message || 'Fehler beim Senden der Test-Email');
      console.error(error);
    } finally {
      setTesting(false);
    }
  };

  if (loading) {
    return <div className="settings-loading">Laden...</div>;
  }

  return (
    <div className="settings-page">
      <h2>Einstellungen</h2>

      {error && (
        <div className="alert alert-error">
          {error}
          <button onClick={() => setError('')}>×</button>
        </div>
      )}
      
      {success && (
        <div className="alert alert-success">
          {success}
          <button onClick={() => setSuccess('')}>×</button>
        </div>
      )}

      <div className="settings-card">
        <div className="card-header">
          <span className="icon">📧</span>
          <h3>E-Mail Konfiguration</h3>
        </div>

        <div className="settings-form">
          <div className="form-row">
            <div className="form-group flex-3">
              <label>SMTP Server</label>
              <input
                type="text"
                value={settings.smtp_host}
                onChange={handleChange('smtp_host')}
                placeholder="z.B. mail.example.com"
              />
            </div>
            <div className="form-group flex-1">
              <label>Port</label>
              <input
                type="text"
                value={settings.smtp_port}
                onChange={handleChange('smtp_port')}
                placeholder="587"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Benutzername / E-Mail</label>
              <input
                type="text"
                value={settings.smtp_user}
                onChange={handleChange('smtp_user')}
                placeholder="user@example.com"
              />
            </div>
            <div className="form-group">
              <label>Passwort</label>
              <div className="password-input">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={settings.smtp_password}
                  onChange={handleChange('smtp_password')}
                />
                <button 
                  type="button" 
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>
          </div>

          <hr />
          <h4>Absender</h4>

          <div className="form-row">
            <div className="form-group">
              <label>Absendername</label>
              <input
                type="text"
                value={settings.smtp_from_name}
                onChange={handleChange('smtp_from_name')}
                placeholder="Obstnatur"
              />
            </div>
            <div className="form-group">
              <label>Absender E-Mail</label>
              <input
                type="email"
                value={settings.smtp_from_email}
                onChange={handleChange('smtp_from_email')}
                placeholder="rechnung@obstnatur.de"
              />
              <small>Leer = SMTP Benutzername wird verwendet</small>
            </div>
          </div>

          <div className="form-actions">
            <button 
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? 'Speichern...' : '💾 Speichern'}
            </button>
          </div>
        </div>
      </div>

      <div className="settings-card">
        <h3>E-Mail Test</h3>
        <p className="hint">Senden Sie eine Test-E-Mail um die Konfiguration zu prüfen.</p>
        
        <div className="test-form">
          <input
            type="email"
            value={testEmail}
            onChange={(e) => setTestEmail(e.target.value)}
            placeholder="test@example.com"
          />
          <button
            className="btn btn-secondary"
            onClick={handleTest}
            disabled={testing || !settings.smtp_host}
          >
            {testing ? 'Senden...' : '📤 Test senden'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
